import { useEditor } from "features/editor/Feature";
import { usePitcher } from "features/utils/usePitcher";
import { Stack, Button, styled, onGrid } from "prism-react";
import { useEffect } from "react";

import { useProjectSettingsContext } from "./SettingsProvider";

const NavButton = styled(Button, {
  justifyContent: "start",
  color: "$neutral-fg-subtle",
  width: "100%",
  marginLeft: "-$2",

  variants: {
    isActive: {
      true: {
        color: "$neutral-fg-high",
      },
    },
  },
});

export const SettingsModalNav = () => {
  const { setActiveTab, activeTab } = useProjectSettingsContext();
  const pitcher = usePitcher();
  const editor = useEditor();

  useEffect(() => {
    if (
      activeTab === "repository" &&
      !pitcher.hasFeature("SET_BRANCH_PROTECTION")
    ) {
      setActiveTab("env");
    }
  }, [activeTab]);

  return (
    <Stack
      as="nav"
      css={{
        height: "100%",
        alignItems: "flex-start",
        marginTop: "$3",
        minWidth: onGrid(36),
      }}
      gap={1}
      role="tablist"
    >
      <NavButton
        isActive={activeTab === "preferences"}
        onClick={() => setActiveTab("preferences")}
      >
        Editor
      </NavButton>

      {pitcher.hasFeature("SET_BRANCH_PROTECTION") &&
        editor.allowedCapabilities.branch &&
        editor.type === "branch" && (
          <NavButton
            isActive={activeTab === "repository"}
            onClick={() => setActiveTab("repository")}
          >
            Repository
          </NavButton>
        )}

      {editor.type === "sandbox" && editor.isCloud && (
        <NavButton
          isActive={activeTab === "devbox"}
          onClick={() => setActiveTab("devbox")}
        >
          Devbox
        </NavButton>
      )}

      {editor.allowedCapabilities.secrets && (
        <NavButton
          isActive={activeTab === "env"}
          onClick={() => setActiveTab("env")}
        >
          Env Variables
        </NavButton>
      )}

      <NavButton
        isActive={activeTab === "experiments"}
        onClick={() => setActiveTab("experiments")}
      >
        Experiments
      </NavButton>
    </Stack>
  );
};
